import {useMsal} from '@azure/msal-react';
import {useEffect} from 'react';
import {authScopes} from 'src/app/constants/config/authConfig';
import {isDevBypassEnabled} from 'src/app/constants/config/devBypassConfig';

/** Attempts to login via SSO if any active user is found within Azure AD */
export const useMsalSso = () => {
    const {instance} = useMsal();

    useEffect(() => {
        if (isDevBypassEnabled) {
            return;
        }

        // Only attempt SSO if there's no active account already
        if (instance.getActiveAccount()) {
            return;
        }

        const requestSso = async () => {
            const request = {
                scopes: authScopes,
            };
            try {
                const loginResponse = await instance.ssoSilent(request);
                instance.setActiveAccount(loginResponse.account);
            } catch (err) {
                /* eslint-disable-next-line no-console */
                console.error(err);
            }
        };

        requestSso();
        // Only run once on mount, regardless of instance changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
